module.exports = "../../app/cells/components/campaigns/widgets/discount_label_cell.rb";